module.exports = __webpack_public_path__ + "media/images/championship__iconCorrect-99f2697a2a0c86ceca70348913a836ac.png";